var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circle-button",class:{ selected: _vm.selected },style:(_vm.styles)},[_c('FontAwesomeIcon',{attrs:{"icon":['fad', _vm.icon],"fixed-width":"","size":"lg","swap-opacity":_vm.swapColours}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }